import {QuoteTemplateParams} from '../quoteTemplateParams';
import {highlightYellow} from '../../helpers/highlightYellow';

import {emailHeaderCompanyLogo, paragraphSeparator} from '../../helpers/commonEmailComponents';
import RootStore from '@/Core/mobx/RootStore';

export default function afterSaleIULNonblend(params: QuoteTemplateParams) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const {
        name,
        manager_name: managerName,
        monthly_premium: monthlyPremium,
        cash_age: cashAge,
        cash_value: cashValue,
        life_coverage: lifeCoverage,
        carrier_name: carrierName,
        has_illustration: hasIllustration,
    } = params;
    const agent = RootStore.agentPortalStore?.parameterStore?.approval?.agentName?.value;

    const managerMessage =
        managerName?.includes('Korinne') || managerName?.includes('Namid')
            ? `<span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">I have also attached your in-depth policy outline for your records as created and reviewed by myself and my manager, ${managerName}.</span> </p> ${paragraphSeparator}`
            : managerName && managerName?.length > 0
              ? `<span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">I have also attached your in-depth policy outline for your records as created and reviewed by our quality assurance manager, ${managerName}.</span> </p> ${paragraphSeparator}`
              : '</p>';

    return `
${emailHeaderCompanyLogo} 
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Hi ${highlightYellow(name)},</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Congratulations on submitting your life insurance application! You are one step closer to getting the coverage you need while building your wealth through an IUL.</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">To summarize, here are the policy details we discussed:</span>
    </p>
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span style="background-color: #ffffff; font-size: 12pt; font-family: 'Georgia'; font-weight: 400;">&#9989;
        </span><span
            style="color: #000000; font-weight: 700; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">${lifeCoverage}</span>
            <span style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;"> life, critical, chronic, and terminal illness protection for the rest of life</span>
    </p>
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span style="background-color: #ffffff; font-size: 12pt; font-family: 'Georgia'; font-weight: 400;">&#9989;
        </span><span
            style="color: #000000; font-weight: 700; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;"><span>${highlightYellow(cashValue)}</span>
            <span style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;"> tax-free retirement cash at age </span>
            <span>${highlightYellow(cashAge)}</span>
    </p>
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span style="background-color: #ffffff; font-size: 12pt; font-family: 'Georgia'; font-weight: 400;">&#9989;
        </span><span
            style="color: #000000; font-weight: 700; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">${monthlyPremium}</span>
            <span style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;"> per month</span>
    </p>
    ${
        hasIllustration
            ? `${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        ${managerMessage}
    `
            : ''
    }
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Our case management team and I will be tracking your application through the underwriting process. We will reach out if there are any additional requirements from the carrier.</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">As soon as we get your approval, myself or a Policy Review Specialist will reach out to help walk you through the steps needed to activate your policy.</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">If you have any questions, feel free to reach out. If you want to learn more about life insurance and its benefits, check out our <span
            style="text-decoration-skip-ink: none; -webkit-text-decoration-skip: none; color: #1155cc; text-decoration: underline;"><a
                href="https://www.getamplifylife.com/guide"
                style="color: inherit; text-decoration: inherit;">Guide to Life Insurance</a></span>.</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Thank you again for trusting Amplify with your financial future, and I look forward to speaking with you soon!</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Best Regards,</span>
    </p>
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">${highlightYellow('[Agent signature]')}</p>
`;
}
